
import { defineComponent, ref } from "vue-demi";
import { isIncludedInPackage } from "@/constants/subscription";

export default defineComponent({
  name: "MockAudit",

  components: {
    Popup: () => import("@/modules/Pricing/Popup/Popup.vue"),
    FormsTemplate: () => import("@/modules/Pricing/Services/Forms/FormsTemplate.vue"),
  },

  emits: ["ok", "cancel", "close"],

  setup(_, { emit }) {
    const isPopoverOpen = ref(true);

    const onOk = () => {
      emit("ok");
    };

    const onCancel = () => {
      isPopoverOpen.value = false;

      emit("cancel");
    };

    const onClose = () => {
      isPopoverOpen.value = false;

      emit("close");
    };

    return {
      isPopoverOpen,
      onOk,
      onCancel,
      onClose,
      isIncludedInPackage,
    };
  },
});
